import React from "react";
import { useParams } from "react-router-dom";
import "./css/NotebookPage.css";
import axios from "axios";
import { API_BASE } from "./config";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NotebookPage() {
    const { executionId } = useParams();
    const navigate = useNavigate();
    const [shuttingDown, setShuttingDown] = useState(false);
    const [confirmStop, setConfirmStop] = useState(false);
    const terminateNotebook = async () => {
        setShuttingDown(true);

        try {
            await axios.post(`https://cloudgenomics.net/api/terminate-notebook`, { executionId });

            setConfirmStop(false); // close modal

            setTimeout(() => {
            navigate("/analyses");
            }, 1200);

        } catch (err) {
            console.error("Terminate failed:", err);
            alert("Failed to stop notebook.");
        } finally {
            setShuttingDown(false);
        }
    };

    return (
        <div style={{  textAlign: "center" }}>
            <div className="notebook-wrapper">
                <button
                    type="button"
                    className="terminate-button"
                    onClick={() => setConfirmStop(true)}
                    disabled={shuttingDown}
                    >
                    {shuttingDown ? "Stopping…" : "Stop Notebook"}
                </button>
                {confirmStop && (
                    <div className="confirm-overlay">
                        <div className="confirm-box">
                        <h3>Stop Notebook?</h3>
                        <p>This will terminate the running notebook session.</p>

                        <div className="confirm-actions">
                            <button
                            className="confirm-stop"
                            onClick={terminateNotebook}
                            >
                            Yes, Stop
                            </button>

                            <button
                            className="confirm-cancel"
                            onClick={() => setConfirmStop(false)}
                            >
                            Cancel
                            </button>
                        </div>
                        </div>
                    </div>
                )}
                <br />
                <iframe
                title="Notebook"
                src={`https://notebooks.cloudgenomics.net/notebook/${executionId}/lab`}
                className="notebook-iframe"
            />
            </div>
        </div>
    );
}
